import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Dialog, DialogContent } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import UpdateTaskInformation from './UpdateTaskInformation';

const getDisplayValue = (value) => value || null;

const COLUMNS = [
    { key: 'label', label: 'Updated Field', className: 'narrowColumn' },
    { key: 'updated_by', label: 'Updated By', className: 'narrowColumn' },
    { key: 'updated_on', label: 'Updated On', className: 'dateColumn' },
    { key: 'reason', label: 'Reason', className: 'reasonColumn' },
];

const useStyles = makeStyles(() => ({
    tableWrapper: {
        width: '101%',
        //borderRadius: '10px',
        overflowX: 'auto',
        overflowY: 'auto',
        //maxHeight: 'calc(100vh - 194.5px)',
        //border: '1px solid #000000',
        //boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        // Thin scrollbar matching the CPS cgrid table scroll style
        '&::-webkit-scrollbar': {
            width: '8px',
            height: '10px'
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#a8a8a8',
            borderRadius: '4px',
            '&:hover': {
                background: '#888'
            },
        },
        '& table': {
            width: '100%',
            minWidth: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'separate',
            marginLeft: '-2px',
            paddingRight: '6px',
        },
        '& thead': {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: '#C4D2E2',
        },
        '& th': {
            padding: '3px 16px',
            //textAlign: 'center',
            color: '#202124',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid #c8cbce',
            letterSpacing: '0.3px',
            whiteSpace: 'nowrap',
            background: '#C4D2E2',
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .narrowColumn': {
            width: '18%'
        },
        '& .dateColumn': {
            width: '20%'
        },
        '& .reasonColumn': {
            width: '44%'
        },
        '& tbody tr': {
            height: '4vh',
            background: '#f7fafd',
            fontWeight: 600,
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            //background: '#dee2e6',
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '2px 16px',
            textAlign: 'left',
            color: '#334155',
            fontSize: '0.85rem',
            fontWeight: 600,
            borderRight: '1px solid #edf2f7',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
    taskUpdateHeader: {
        fontWeight: 'bold',
        backgroundColor: '#8CC0E0',
        height: '4.5vh',
        paddingLeft: '17px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginRight: '10px'
    },
    editIcon: {
        marginLeft: '18px',
        cursor: 'pointer',
        fontSize: 'medium',
        color: 'white',
        marginBottom: '3px'
    },
    dialogPaper: {
        width: '650px',
        maxWidth: 'calc(100vw - 32px)',
        height: '360px',
        maxHeight: 'calc(100vh - 32px)'
    },
    dialogContent: {
        padding: '0 !important'
    },
}));

const TaskInformationTable = ({ taskUpdateRows = [], taskId, onUpdateSuccess }) => {
    const classes = useStyles();
    const [isUpdateTaskInformationOpen, setIsUpdateTaskInformationOpen] = useState(false);

    return (
        <div>
            <div className={classes.tableWrapper}>
                <div className={classes.taskUpdateHeader}>Task Update<span><EditIcon aria-label="Update Task Information" className={classes.editIcon} onClick={() => setIsUpdateTaskInformationOpen(true)} /></span></div>
                <table>
                    <thead>
                        <tr>
                            {COLUMNS.map((column) => <th className={column.className} key={column.key}>{column.label}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {taskUpdateRows.map((row) => (
                            <tr key={row.key}>
                                {COLUMNS.map((column) => <td className={column.className} key={column.key}>{getDisplayValue(row[column.key])}</td>)}
                            </tr>
                        ))}
                        {taskUpdateRows.length === 0 && (
                            <tr>
                                <td colSpan={COLUMNS.length}>No task updates found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Dialog
                open={isUpdateTaskInformationOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        setIsUpdateTaskInformationOpen(false);
                    }
                }}
                maxWidth={false}
                PaperProps={{
                    className: classes.dialogPaper
                }}
            >
                <DialogContent className={classes.dialogContent}>
                    <UpdateTaskInformation
                        taskId={taskId}
                        onClose={() => setIsUpdateTaskInformationOpen(false)}
                        onUpdateSuccess={onUpdateSuccess}
                    />
                </DialogContent>
            </Dialog>
        </div>
    )
}
export default TaskInformationTable;

